import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaRobot, FaTimes, FaPaperPlane } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './chat.css';


const Chat = ({ bikes }) => {
  const [input, setInput] = useState('');
  const [selectedBike, setSelectedBike] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [botResponse, setBotResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const chatRef = useRef(null);
  const modalRef = useRef(null);

  const handleClose = () => {
    setShowModal(false);
  };

const getModelFromBikeName = (name) => {
  if (!name) return null;

  return name
    .replace(/^Matchless\s+/i, '')  // remove "Matchless "
    .replace(/^WD\s+/i, '')         // remove "WD "
    .trim();
};

const fetchMessage = async () => {

    console.log(selectedBike.year)
  const response = await fetch('https://im6nc6crmemhhpkldwk53u4rpi0aggam.lambda-url.eu-north-1.on.aws/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      question: input,
      bike: selectedBike
        ? {
            name: selectedBike.name,
            model: getModelFromBikeName(selectedBike.name),
            year: selectedBike.year,
            engine: selectedBike.engine,
            gearbox: selectedBike.gearbox,
            topSpeed: selectedBike.topSpeed,
            horsepower: selectedBike.horsepower,
            description: selectedBike.description,
            commonIssues: selectedBike.commonIssues,
            maintenance: selectedBike.maintenance,
          }
        : null,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    console.error(data);
    return 'Sorry, I had trouble answering that.';
  }

  console.log('Jam-Bot debug:', data.debug);

  return data?.answer?.trim() || 'No response received.';
};

  const sendMessage = async () => {
    if (!input.trim() || loading) return;

    setLoading(true);
    setBotResponse('');

    const response = await fetchMessage();

    setBotResponse(response);
    setShowModal(true);
    setInput('');
    setLoading(false);
  };

  const handleBikeChange = (e) => {
    const bikeName = e.target.value;
    const selectedBikeObj = bikes.find((bike) => bike.name === bikeName);
    setSelectedBike(selectedBikeObj || null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (chatRef.current && chatRef.current.contains(event.target)) ||
        (modalRef.current && modalRef.current.contains(event.target))
      ) {
        return;
      }

      setShowChat(false);
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  return (
    <>
      {!showChat && (
        <button
          className="jam-bot-fab"
          onClick={() => setShowChat(true)}
          aria-label="Open Jam-Bot"
        >
          <FaRobot size={26} />
        </button>
      )}

      {showChat && (
        <div ref={chatRef} className="jam-bot-panel">
          <div className="jam-bot-header">
            <div>
              <div className="jam-bot-kicker">Workshop Assistant</div>
            </div>

            <button
              className="jam-bot-close"
              onClick={() => setShowChat(false)}
              aria-label="Close chat"
            >
              <FaTimes />
            </button>
          </div>

          <p className="jam-bot-description">
            Ask about maintenance, adjustments, and workshop procedures for your selected bike.
          </p>

          <div className="jam-bot-form">
            <label className="jam-bot-label">Select Bike</label>
            <select
            value={selectedBike ? selectedBike.name : ''}
            onChange={handleBikeChange}
            className="jam-bot-select"
          >
            <option value="">Select Bike</option>

            {bikes
              .filter((bike) => bike.hasManual)
              .map((bike) => (
                <option key={bike.name} value={bike.name}>
                  {bike.name} ({bike.year})
                </option>
              ))}
          </select>



            <label className="jam-bot-label">Question</label>
            <textarea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  sendMessage();
                }
              }}
              placeholder={
                selectedBike
                  ? `Ask something about the ${selectedBike.name}...`
                  : 'Select a bike first, then ask a question...'
              }
              className="jam-bot-textarea"
              rows={4}
            />

            <Button
              onClick={sendMessage}
             disabled={loading || !selectedBike || !input.trim()}
              className="jam-bot-send"
            >
              {loading ? 'Thinking...' : <>Ask Jam-Bot <FaPaperPlane style={{ marginLeft: 8 }} /></>}
            </Button>
          </div>

          {selectedBike && (
            <div className="jam-bot-selected-bike">
              Working on: <strong>{selectedBike.name}</strong> <span>({selectedBike.year})</span>
            </div>
          )}

          <Modal
            show={showModal}
            onHide={handleClose}
            centered
            dialogClassName="jam-bot-modal"
            contentClassName="jam-bot-modal-content"
          >
            <div ref={modalRef}>
              <Modal.Header closeButton className="jam-bot-modal-header">
                <div>
                  <div className="jam-bot-kicker">Jam-Bot Advice</div>
                  <Modal.Title className="jam-bot-modal-title">
                    {selectedBike ? `${selectedBike.name}` : 'Workshop Answer'}
                  </Modal.Title>
                </div>
              </Modal.Header>

              <Modal.Body className="jam-bot-modal-body">
                <div className="jam-bot-answer">
                  {botResponse.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              </Modal.Body>

              <Modal.Footer className="jam-bot-modal-footer">
                <Button variant="secondary" onClick={handleClose} className="jam-bot-secondary-btn">
                  Close
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default Chat;